import { getClassDisplayName, getClassOptionLabel } from "../../utils/classPresentation";
import ClassPresentation from "../../Components/ClassPresentation";
import React, { useEffect, useState } from "react";
import { FiCheck, FiCheckCircle, FiX, FiXCircle } from "react-icons/fi";
import MenuLateral from "../../Components/MenuLateral";
import CadastroPageHeader from "../../Components/CadastroPageHeader";
import api from "../../services/api";
import { showApiError } from "../../services/showApiError";
import AuthenticatedMedia from "../../Components/AuthenticatedMedia";
import FieldLabel from "../../Components/FieldLabel";
import Swal from "sweetalert2";
import "./index.css";
import "../../styles/cadastro-pages.css";

function CadAprovAlunoExt() {
  const [listaOriginal, setListaOriginal] = useState([]);
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [instituicoes, setInstituicoes] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [institutionId, setInstitutionId] = useState("");
  const [classId, setClassId] = useState("");
  const [modal, setModal] = useState(false);
  const [selecionado, setSelecionado] = useState(null);
  const [mostrarFinalizados, setMostrarFinalizados] = useState(false);
  const [decidindo, setDecidindo] = useState(false);

  const carregarSolicitacoes = async () => {
    try {
      const resp = await api.get("/students/requests");
      const data = resp.data.requests || [];
      const instMap = new Map();

      data.forEach((item) => {
        const inst = item.class?.institution;
        if (inst) instMap.set(inst.id, inst);
      });

      setListaOriginal(data);
      setListaFiltrada(data);
      setInstituicoes([...instMap.values()]);
    } catch (error) {
      showApiError(error, "Erro ao carregar");
    }
  };

  useEffect(() => {
    carregarSolicitacoes();
    // Esta carga ocorre apenas na montagem da pagina.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!institutionId) {
      setTurmas([]);
      setClassId("");
      return;
    }

    const lista = listaOriginal
      .filter((item) => String(item.class?.institution?.id) === institutionId)
      .map((item) => item.class)
      .filter((value, index, array) => value && array.findIndex((item) => item.id === value.id) === index);

    setTurmas(lista);
  }, [institutionId, listaOriginal]);

  useEffect(() => {
    let lista = [...listaOriginal];

    if (!mostrarFinalizados) {
      lista = lista.filter((item) => item.status === "pending");
    }

    if (institutionId) {
      lista = lista.filter((item) => String(item.class?.institution?.id) === institutionId);
    }

    if (classId) {
      lista = lista.filter((item) => String(item.class?.id) === classId);
    }

    setListaFiltrada(lista);
  }, [institutionId, classId, listaOriginal, mostrarFinalizados]);

  const abrirDetalhe = async (id) => {
    try {
      const resp = await api.get(`/students/requests/${id}`);
      setSelecionado(resp.data.request);
      setModal(true);
    } catch (error) {
      showApiError(error);
    }
  };

  const decidir = async (decision) => {
    const requestInReview = selecionado;
    if (!requestInReview) return;

    const isApproval = decision === "approve";
    const actionLabel = isApproval ? "aprovar" : "rejeitar";
    setModal(false);

    const result = await Swal.fire({
      title: `Motivo para ${actionLabel}`,
      input: "textarea",
      inputLabel: "Registre o motivo da decisão",
      inputValidator: (value) => (!value?.trim() ? "Informe o motivo da decisão." : undefined),
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    });

    const reason = result?.value?.trim();
    if (!result?.isConfirmed || !reason) {
      setModal(true);
      return;
    }

    const confirmation = await Swal.fire({
      icon: "warning",
      title: isApproval ? "Confirmar aprovação?" : "Confirmar rejeição?",
      text: isApproval
        ? "A aprovação provisionará a conta e o perfil do aluno."
        : "A rejeição encerrará esta solicitação e liberará um novo envio futuro.",
      showCancelButton: true,
      confirmButtonText: `Sim, ${actionLabel}`,
      cancelButtonText: "Voltar",
    });

    if (!confirmation?.isConfirmed) {
      setModal(true);
      return;
    }

    setDecidindo(true);
    try {
      await api.post(`/students/requests/${requestInReview.id}/${decision}`, { reason });
      await Swal.fire({
        icon: "success",
        title: isApproval ? "Solicitação aprovada" : "Solicitação rejeitada",
        text: isApproval
          ? "A conta e o perfil do aluno foram provisionados."
          : "A solicitação foi rejeitada e o novo cadastro poderá ser enviado futuramente.",
      });
      setModal(false);
      await carregarSolicitacoes();
    } catch (error) {
      await showApiError(error, "Não foi possível registrar a decisão");
      setModal(true);
    } finally {
      setDecidindo(false);
    }
  };

  const statusLabel = (status) => {
    if (status === "pending") return "Pendente";
    if (status === "approved") return "Aprovado";
    if (status === "rejected") return "Rejeitado";
    return status;
  };

  const classRoleLabel = (role) => {
    if (role === "treasurer") return "Tesoureiro";
    if (role === "president") return "Presidente";
    return "Nenhum cargo";
  };

  const enderecoCompleto = (item) =>
    [
      item.street,
      item.number,
      item.complement,
      item.district,
      item.city,
      item.uf,
      item.zipCode,
    ]
      .filter(Boolean)
      .join(", ") || "-";

  return (
    <div className="pagina-cad cadastro-shell cadastro-shell-aprovacoes">
      <MenuLateral />

      <div className="conteudo-cad">
        <CadastroPageHeader
          eyebrow="Cadastros / Revisão"
          title="Aprovação de cadastros externos"
          description="Revise os dados enviados por alunos e tome decisões com o contexto necessário."
          icon={FiCheckCircle}
          context="Fila de revisão"
          contextDetail="Pendências organizadas por instituição e turma"
        />

        <section className="cadastro-list-panel" aria-labelledby="aprovacoes-list-title">
        <div className="cadastro-list-heading">
          <div>
            <span className="cadastro-list-kicker">Fila administrativa</span>
            <h2 id="aprovacoes-list-title">Cadastros para revisar</h2>
            <p>Filtre o contexto, abra os dados completos e registre a decisão.</p>
          </div>
          <span className="cadastro-list-count">{listaFiltrada.length} {listaFiltrada.length === 1 ? "item" : "itens"}</span>
        </div>

        <div className="filtros">
          <FieldLabel label="Instituição">
            <select value={institutionId} onChange={(event) => setInstitutionId(event.target.value)}>
              <option value="">Instituicao</option>
              {instituicoes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </FieldLabel>

          <FieldLabel label="Turma">
            <select value={classId} onChange={(event) => setClassId(event.target.value)} disabled={!institutionId}>
              <option value="">Turma</option>
              {turmas.map((item) => (
                <option key={item.id} value={item.id}>
                  {getClassOptionLabel(item)}
                </option>
              ))}
            </select>
          </FieldLabel>
        </div>

        <div className="filtro-status">
          <label>
            <input
              type="checkbox"
              checked={mostrarFinalizados}
              onChange={(event) => setMostrarFinalizados(event.target.checked)}
            />
            Mostrar aprovados e rejeitados
          </label>
        </div>

        <div className="cadastro-table-wrap">
        <table className="grid-cad">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Turma</th>
              <th>Instituicao</th>
              <th>Status</th>
              <th>Acoes</th>
            </tr>
          </thead>
          <tbody>
            {listaFiltrada.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{getClassDisplayName(item.class)}</td>
                <td><small>{item.class?.institution?.name || "Instituição não informada"}</small></td>
                <td>
                  <span className={`badge ${item.status.toLowerCase()}`}>{statusLabel(item.status)}</span>
                </td>
                <td>
                  <button onClick={() => abrirDetalhe(item.id)}>Ver</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        </section>
      </div>

      {modal && selecionado && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div
            className="modal-card aprov-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="aprov-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <header className="aprov-modal-header">
              <div>
                <span className={`badge ${selecionado.status.toLowerCase()}`}>{statusLabel(selecionado.status)}</span>
                <h3 id="aprov-modal-title">{selecionado.name}</h3>
                <ClassPresentation schoolClass={selecionado.class} />
              </div>
              <button className="modal-close" type="button" onClick={() => setModal(false)}>
                <FiX aria-hidden="true" />
                <span className="visually-hidden">Fechar detalhes</span>
              </button>
            </header>

            <div className="modal-body aprov-modal-body">
              <aside className="aprov-photo-panel">
                {selecionado.photoTempMedia?.path ? (
                  <AuthenticatedMedia path={selecionado.photoTempMedia.path} alt={`Foto de ${selecionado.name}`} />
                ) : (
                  <div className="aprov-photo-empty">Sem foto</div>
                )}
              </aside>

              <section className="aprov-info-panel">
                <div className="aprov-info-grid">
                  <div><span>Email</span><strong>{selecionado.email || "-"}</strong></div>
                  <div><span>CPF</span><strong>{selecionado.cpf || "-"}</strong></div>
                  <div><span>Nascimento</span><strong>{selecionado.birthDate || "-"}</strong></div>
                  <div><span>Apelido</span><strong>{selecionado.nickname || "-"}</strong></div>
                  <div><span>Telefone</span><strong>{selecionado.phone || "-"}</strong></div>
                  <div><span>Celular</span><strong>{selecionado.mobilePhone || "-"}</strong></div>
                  <div><span>Matricula</span><strong>{selecionado.registrationNumber || "-"}</strong></div>
                  <div><span>Cargo na turma</span><strong>{classRoleLabel(selecionado.classRole)}</strong></div>
                </div>

                <div className="aprov-info-block">
                  <span>Endereco</span>
                  <strong>{enderecoCompleto(selecionado)}</strong>
                </div>

                <div className="aprov-info-grid compact">
                  <div><span>Responsavel financeiro</span><strong>{selecionado.isFinancialResponsible ? "Sim" : "Nao"}</strong></div>
                  <div><span>Endereco de cobranca</span><strong>{selecionado.isBillingAddress ? "Sim" : "Nao"}</strong></div>
                </div>

                {selecionado.rejectionReason && (
                  <div className="aprov-info-block">
                    <span>Motivo da decisão</span>
                    <strong>{selecionado.rejectionReason}</strong>
                  </div>
                )}
              </section>
            </div>

            {selecionado.status === "pending" && (
              <footer className="aprov-modal-footer">
                <button className="aprov-decision-button is-danger" type="button" disabled={decidindo} onClick={() => decidir("reject")}>
                  <FiXCircle aria-hidden="true" />
                  {decidindo ? "Registrando..." : "Rejeitar"}
                </button>
                <button className="aprov-decision-button is-success" type="button" disabled={decidindo} onClick={() => decidir("approve")}>
                  <FiCheck aria-hidden="true" />
                  {decidindo ? "Registrando..." : "Aprovar"}
                </button>
              </footer>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CadAprovAlunoExt;
